// We are relying on jQuery being called in a separate script file.
var $ = window.jQuery;


/* ==========================================================================
   THEME ES6 COMPONENTS -- WOOCOMMERCE
   ========================================================================== */
import '../../../../../bower_components/slick-carousel/slick/slick';


// These match the css media breakpoints. They are used for the slider settings.
// TODO: this might not be the best place to store these variables.
const xsBreakpoint = 480;
const smBreakpoint = 768;
const mdBreakpoint = 992;
const lgBreakpoint = 1200;
const xlBreakpoint = 1400;


// Settings for the gallery image sliders
const sliderSettings = {
    vertical: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [ // responsive breakpoints work ** downwards **... the breakpoint is the max-width
            {
                breakpoint: smBreakpoint,
                settings: {
                    vertical: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    // centerMode: true
                }
            },
            {
                breakpoint: xsBreakpoint,
                settings: {
                    vertical: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    // centerMode: true
                }
            }]
};

var default_image = false;

export default class SingleProduct {

    // start here.
    constructor (options) {
        if (this.isSingleProductPage) {
            this.activateImageSlider();
            this.activateLightboxes();
            this.initMainImageSwitcher();
        }
    }

    // helper for checking if on the single product page
    isSingleProductPage() {
        return $(document.body).is('.single-product');
    }

    // activate image gallery slider
    activateImageSlider() {
        // activate slider for product
        var thumbnails = $('.single-product__images .thumbnails');
        if (thumbnails.find('a').length < sliderSettings.slidesToShow) {
            thumbnails.addClass('has-few-slides');
        }
        thumbnails.slick(
            sliderSettings
        );
    }

    // activate lightboxes on click of product images.
    activateLightboxes() {

        if ($.magnificPopup) {
            // For the product thumbnails. This replaces the Pretty Photo functionality built in with woocommerce.
            $('.single-product__thumbnails, .single-product__image--main').magnificPopup({
                delegate: 'a',
                type: 'image',
                gallery: {
                    enabled: true
                }
            });
        } else {
            console.warn("woocommerce/single-product.js: Magnific Popup is not installed. Lightboxes won't work on the single product page");
        }
    }

    initMainImageSwitcher() {
        var $img = $('.single-product__image--main img');
        default_image = {
            src: $img.attr('src'),
            srcset: $img.attr('srcset'),
            sizes: $img.attr('sizes'),
        };

        $('.images').on('woocommerce_gallery_reset_slide_position', function(event) {
            var $images = $(this);
            var $img = $images.find('.single-product__image--main img');
            var $form = $images.parents('.product').find('form');

            if($form.length) {
                var image = $form.attr('current-image');

                var data = $form.data('product_variations');
                if(typeof data == String) {
                    data = JSON.parse(data);
                }

                if(image && data) {
                    for(var i in data) {
                        if(data[i].image_id == image) {
                            $img.attr('src', data[i].image.src);
                            $img.attr('srcset', data[i].image.srcset);
                            $img.attr('sizes', data[i].image.sizes);
                            break;
                        }
                    }
                }
                else if(default_image) {
                    $img.attr('src', default_image.src);
                    $img.attr('srcset', default_image.srcset);
                    $img.attr('sizes', default_image.sizes);
                }
            }
        });
    }


}
